"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormImportCtrl = void 0;
const tslib_1 = require("tslib");
const core_shared_1 = require("@ikegps/core-shared");
const mobx_1 = require("mobx");
const notification_service_1 = require("../../components/notification.toast/notification.service");
const i18n_1 = require("../../i18n");
const services_1 = require("../../services");
const mobx_2 = require("../../state/mobx");
const store_1 = require("../../store");
const upload_reader_1 = require("../../util/upload.reader");
class FormImportCtrl extends mobx_2.MobxState {
    constructor() {
        super();
        this.file = null;
        this.isActive = false;
        this.secondaryFormId = null;
        this.fileId = 'file-' + core_shared_1.IkeId.generate();
    }
    reset() {
        this.file = null;
    }
    openFileDialog(e) {
        e.preventDefault();
        const fileInput = document.getElementById(this.fileId);
        if (fileInput == null) {
            throw new Error('Unable to find file input: "' + this.fileId + '\'');
        }
        const evt = document.createEvent('MouseEvents');
        evt.initEvent('click', true, false);
        fileInput.dispatchEvent(evt);
    }
    onFile(e) {
        const fileInput = e.target;
        if (fileInput == null) {
            throw new Error('Unable to find file input: "' + this.fileId + '\'');
        }
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.FormImportUpload, 'file:click', 'button', 1);
        this.loadFiles(fileInput.files);
    }
    loadFiles(files) {
        this.file = null;
        if (!files || files.length === 0) {
            return;
        }
        const file = files[0];
        const hasAllowedSuffix = FormImportCtrl.ALLOWED_SUFFIXES.some(suffix => file.name.endsWith(suffix));
        if (!hasAllowedSuffix) {
            notification_service_1.NotificationService.error({ key: i18n_1.T.FILE_NOT_SUPPORTED });
            return;
        }
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.FormImportUpload, 'file:count', '1', 1);
        this.file = new upload_reader_1.UniversalFileUploadReader(file, undefined);
    }
    processFile() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.file && this.file.buffer) {
                const rest = services_1.Services.Department.rest;
                try {
                    const attachment = yield rest.Attachment.set(this.file.name, this.file.buffer, this.file.type);
                    yield rest.Attachment.antivirusScan(attachment.objectId);
                    const regexPattern = FormImportCtrl.REPLACED_SUFFIXES.map(suffix => '\\' + suffix).join('|');
                    const regex = new RegExp(regexPattern, 'g');
                    yield rest.Form.Pla.import(Object.assign({ attachmentId: attachment.objectId, name: attachment.name.replace(regex, '') }, (this.secondaryFormId && { revision: this.secondaryFormId })));
                    yield store_1.AppStore.FormSummary.refresh();
                }
                catch (e) {
                    notification_service_1.NotificationService.error({ key: i18n_1.T.ERROR_GENERAL });
                }
            }
        });
    }
}
exports.FormImportCtrl = FormImportCtrl;
FormImportCtrl.COMMON_SUFFIXES = ['.csv', '.db', '.lccfg', '.client'];
FormImportCtrl.ALLOWED_SUFFIXES = [...FormImportCtrl.COMMON_SUFFIXES, '.xlsx', '.dds'];
FormImportCtrl.REPLACED_SUFFIXES = [...FormImportCtrl.COMMON_SUFFIXES, '.poleforeman.xlsx'];
tslib_1.__decorate([
    mobx_1.observable.shallow
], FormImportCtrl.prototype, "file", void 0);
tslib_1.__decorate([
    mobx_1.observable
], FormImportCtrl.prototype, "isActive", void 0);
tslib_1.__decorate([
    mobx_1.action.bound
], FormImportCtrl.prototype, "reset", null);
tslib_1.__decorate([
    mobx_1.action.bound
], FormImportCtrl.prototype, "openFileDialog", null);
tslib_1.__decorate([
    mobx_1.action.bound
], FormImportCtrl.prototype, "onFile", null);
tslib_1.__decorate([
    mobx_1.action.bound
], FormImportCtrl.prototype, "processFile", null);
//# sourceMappingURL=form.import.ctrl.js.map